import React from 'react';

const IconFileSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 0 16 16">
    <g id="icon-file-document">
      <path style={{ fill: '#b7b7b7' }} d="M21.33,1A1.67,1.67,0,0,1,23,2.67V21.33A1.67,1.67,0,0,1,21.33,23H2.67A1.67,1.67,0,0,1,1,21.33V2.67A1.67,1.67,0,0,1,2.67,1H21.33m0-1H2.67A2.66,2.66,0,0,0,0,2.67V21.33A2.66,2.66,0,0,0,2.67,24H21.33A2.66,2.66,0,0,0,24,21.33V2.67A2.66,2.66,0,0,0,21.33,0Z" />
      <g id="lines">
        <rect id="Rectangle_8" data-name="Rectangle 8" style={{ fill: '#b7b7b7' }} x="6.67" y="7.67" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_2" data-name="Rectangle 8_2" style={{ fill: '#b7b7b7' }} x="6.67" y="11" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_3" data-name="Rectangle 8_3" style={{ fill: '#b7b7b7' }} x="6.67" y="14.33" width="6.67" height="2" rx="0.33" ry="0.33" />
      </g>
    </g>
  </svg>
);

const IconFileMedium = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 0 24 24">
    <g id="icon-file-document">
      <path style={{ fill: '#b7b7b7' }} d="M21.33,1A1.67,1.67,0,0,1,23,2.67V21.33A1.67,1.67,0,0,1,21.33,23H2.67A1.67,1.67,0,0,1,1,21.33V2.67A1.67,1.67,0,0,1,2.67,1H21.33m0-1H2.67A2.66,2.66,0,0,0,0,2.67V21.33A2.66,2.66,0,0,0,2.67,24H21.33A2.66,2.66,0,0,0,24,21.33V2.67A2.66,2.66,0,0,0,21.33,0Z" />
      <g id="lines">
        <rect id="Rectangle_8" data-name="Rectangle 8" style={{ fill: '#b7b7b7' }} x="6.67" y="7.67" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_2" data-name="Rectangle 8_2" style={{ fill: '#b7b7b7' }} x="6.67" y="11" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_3" data-name="Rectangle 8_3" style={{ fill: '#b7b7b7' }} x="6.67" y="14.33" width="6.67" height="2" rx="0.33" ry="0.33" />
      </g>
    </g>
  </svg>
);

const IconFileLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="36px" width="36px" viewBox="0 0 36 36">
    <g id="icon-file-document">
      <path style={{ fill: '#b7b7b7' }} d="M21.33,1A1.67,1.67,0,0,1,23,2.67V21.33A1.67,1.67,0,0,1,21.33,23H2.67A1.67,1.67,0,0,1,1,21.33V2.67A1.67,1.67,0,0,1,2.67,1H21.33m0-1H2.67A2.66,2.66,0,0,0,0,2.67V21.33A2.66,2.66,0,0,0,2.67,24H21.33A2.66,2.66,0,0,0,24,21.33V2.67A2.66,2.66,0,0,0,21.33,0Z" />
      <g id="lines">
        <rect id="Rectangle_8" data-name="Rectangle 8" style={{ fill: '#b7b7b7' }} x="6.67" y="7.67" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_2" data-name="Rectangle 8_2" style={{ fill: '#b7b7b7' }} x="6.67" y="11" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_3" data-name="Rectangle 8_3" style={{ fill: '#b7b7b7' }} x="6.67" y="14.33" width="6.67" height="2" rx="0.33" ry="0.33" />
      </g>
    </g>
  </svg>
);

const IconFileXLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="56px" width="56px" viewBox="0 0 56 56">
    <g id="icon-file-document">
      <path style={{ fill: '#b7b7b7' }} d="M21.33,1A1.67,1.67,0,0,1,23,2.67V21.33A1.67,1.67,0,0,1,21.33,23H2.67A1.67,1.67,0,0,1,1,21.33V2.67A1.67,1.67,0,0,1,2.67,1H21.33m0-1H2.67A2.66,2.66,0,0,0,0,2.67V21.33A2.66,2.66,0,0,0,2.67,24H21.33A2.66,2.66,0,0,0,24,21.33V2.67A2.66,2.66,0,0,0,21.33,0Z" />
      <g id="lines">
        <rect id="Rectangle_8" data-name="Rectangle 8" style={{ fill: '#b7b7b7' }} x="6.67" y="7.67" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_2" data-name="Rectangle 8_2" style={{ fill: '#b7b7b7' }} x="6.67" y="11" width="10.67" height="2" rx="0.33" ry="0.33" />
        <rect id="Rectangle_8_3" data-name="Rectangle 8_3" style={{ fill: '#b7b7b7' }} x="6.67" y="14.33" width="6.67" height="2" rx="0.33" ry="0.33" />
      </g>
    </g>
  </svg>
);

const IconFileTypeDocument = {
  Small: IconFileSmall,
  Medium: IconFileMedium,
  Large: IconFileLarge,
  xLarge: IconFileXLarge,
};

export default IconFileTypeDocument;
